import React from 'react';
import moment from "moment";

const mockItems = [
    {id: 1, body: 'no', issuer: 'marios', label: 'first item', value: 1, date: moment('2016-09-13T23:30:52.123Z').format('DD/MM/YYYY - hh:mm:ss')},
    {id: 2, body: 'Yes', issuer: 'marios', label: 'second item!', value: 2, date: moment('2017-09-15T23:30:52.123Z').format('DD/MM/YYYY - hh:mm:ss')},
    {id: 3, body: 'Application was long ago', issuer: 'marios', label: 'third item!', value: 3, date: moment('2018-09-18T23:30:52.123Z').format('DD/MM/YYYY - hh:mm:ss')},
];

const StrikeThroughList = (props) => {
    return (
        <ul className={'list__strikeThrough'}>
            {mockItems.map(item => {
                return (
                    <li key={item.id}>
                        <span className={'text--crossed'}>
                            {item.body}
                        </span>
                        <span>
                            {` at: ${item.date}`}
                        </span>
                    </li>
                )
            })}
        </ul>
    )
};

export default StrikeThroughList